export default "__VITE_ASSET__DkMNNrjs__"